import { render, staticRenderFns } from "./Highlight-tab.vue?vue&type=template&id=57abe976&scoped=true&"
import script from "./Highlight-tab.vue?vue&type=script&lang=js&"
export * from "./Highlight-tab.vue?vue&type=script&lang=js&"
import style0 from "./Highlight-tab.vue?vue&type=style&index=0&id=57abe976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57abe976",
  null
  
)

export default component.exports